import React from "react";
import useWindowSize from "../../../../../hooks/useWindowSize";

export interface ChipTabsOption {
  index: number;
  title: string;
}

export interface ChipTabsProps {
  options: ChipTabsOption[];
  onChangeTab: (option: ChipTabsOption) => void;
}

const ChipTabs: React.FC<ChipTabsProps> = ({ options = [], onChangeTab }) => {
  const { size } = useWindowSize();
  // @ts-ignore
  const isMobileView = (size?.width || 0) <= 768;

  const [activeIndex, setActiveIndex] = React.useState<number>(0);

  if (options?.length <= 0) return null;

  const handleChangeTab = (opt: ChipTabsOption) => {
    setActiveIndex(opt?.index);
    onChangeTab(opt);
  };

  return (
    <React.Fragment>
      {isMobileView ? (
        <div
          style={{
            backgroundColor: "rgba(240, 242, 249, 0.2)",
          }}
          className="flex relative p-[4px] rounded-[40px] h-[32px] max-w-[327px] mx-auto"
        >
          <div
            style={{
              backgroundColor: "#0397C9",
            }}
            className={`absolute top-[4px] bottom-[4px] left-[4px] right-[4px] w-[159px] rounded-full transition-all duration-300 ${
              activeIndex === 1 ? "translate-x-full" : ""
            }`}
          />
          {options?.map((opt, index) => {
            const isActive = activeIndex === index;

            return (
              <div
                onClick={() => handleChangeTab(opt)}
                key={opt?.index}
                className={`cursor-pointer rounded-[40px] w-[159px] p-[8px] flex justify-center items-center`}
              >
                <p
                  className={`text-[12px] uppercase text-white z-10 text-center ${
                    isActive ? "font-[600]" : "font-normal"
                  } `}
                >
                  {opt?.title}
                </p>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="relative p-[16px] rounded-[40px]  flex h-[80px] max-w-[708px] mx-auto bg-[#1F2D3D] bg-opacity-50">
          <div
            style={{
              backgroundColor: "#0397C9",
            }}
            className={`absolute top-[16px] bottom-[16px] left-[16px] right-[16px] w-[330px] rounded-full transition-all duration-300 ${
              activeIndex === 1 ? "translate-x-full" : ""
            }`}
          />
          {options?.map((opt, index) => {
            const isActive = activeIndex === index;
            return (
              <div
                onClick={() => handleChangeTab(opt)}
                key={opt?.index}
                className={`cursor-pointer rounded-[40px] w-[330px] flex justify-center items-center`}
              >
                <p
                  className={`text-[18px] uppercase text-white z-10 ${
                    isActive ? "font-[600]" : "font-normal"
                  }`}
                >
                  {opt?.title}
                </p>
              </div>
            );
          })}
        </div>
      )}
    </React.Fragment>
  );
};

export default ChipTabs;
